import React, {useState} from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {makeStyles} from "@material-ui/core";
import {GOOGLE_MAPS_STATIC_BASE_URL, GOOGLE_MAPS_API_KEY} from "../../common/api/apiConstants";

const useStyles = makeStyles((theme) => ({
    staticMap: {
        display: "block",
        margin: `${theme.spacing(2)}px auto`,
        cursor: "pointer"
    }
}));

export const withMap = (WrappedComponent) => {
    const Map = ({
        placeId,
        embedMapProps,
        staticMapProps
    }) => {

        const [isEmbedMapVisible, setEmbedMapVisible] = useState(false);
        const classes = useStyles();

        const handleStaticMapClick = () => {
            setEmbedMapVisible(true);
        };

        return (
            <>
                {placeId && staticMapProps?.center &&
                    <>
                        {isEmbedMapVisible ? (
                            <WrappedComponent
                                placeId={placeId}
                                {...embedMapProps}
                            />
                        ) : (
                            <img
                                className={clsx(staticMapProps.className, classes.staticMap)}
                                src={`${GOOGLE_MAPS_STATIC_BASE_URL}?center=${staticMapProps.center}&markers=color:red|${staticMapProps.center}&zoom=${staticMapProps.zoom || 13}&size=${staticMapProps.width || 400}x${staticMapProps.height || 400}&key=${GOOGLE_MAPS_API_KEY}`}
                                onClick={() => handleStaticMapClick()}
                                width={staticMapProps.width || 400}
                                height={staticMapProps.height || 400}
                            />
                        )}
                    </>
                }
            </>
        );

    };
    Map.propTypes = {
        embedMapProps: PropTypes.any,
        staticMapProps: PropTypes.shape({
            center: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
            zoom: PropTypes.number,
            className: PropTypes.any
        }),
        placeId: PropTypes.string
    };
    return Map;
};
